module.exports = __webpack_public_path__ + "media/assets/images/smart_working/3-1-648d5bbacd40423635ba02e7249737f7.png";